<template>
  <div class="recapsuite">
    <div class="mainsuite">
      <div class="imgsuite">
        <div class="slideroffre1">
          <ul class="sliderpromo">
            <transition-group name="slide">
              <li class="slideoffre"
                  v-for="(item, index) in pictures"
                  :key="index+item"
                  :class="{ active: index === currentPictureIndex }">
                <img :src="item" @click="openModal(pictures, item)"/>
              </li>
            </transition-group>
          </ul>
          <ul class="dots2">
            <li
              v-for="(dot, index) in pictures"
              :class="{ active: index === currentPictureIndex }"
              @click="goto(index)"
              v-on:mouseover="stopRotation"
              v-on:mouseout="startRotation"
            ></li>
          </ul>
        </div>

      </div>
      <div class="suite-content">
        <div class="header-group">
          <h5>{{name}}</h5>
          <router-link :to="{name: 'roomDetail', params: {id: room.id}}" tag="a">{{$t('discover.step3.goto')}}</router-link>
        </div>

        <div class="description">
          <p v-html="description"></p>
        </div>
        <div class="date" v-if="sameDate" v-html="$t('step2.page.date', `<span>${startDate}</span>`)"></div>
        <div class="date" v-else v-html="$t('step2.page.dates', `<span>${startDate}</span>`, `<span>${endDate}</span>`)"></div>
        <div class="equipment">
          <span v-for="(item, index) in equipments" :index="index" :key="index + item" :item="item">
            <img :src="item" alt=""/>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';
  export default {
    props: ['room', 'start', 'end'],
    name: "room-widget",
    computed: {
      sameDate () {
          return moment(this.start).format('YYYYMMDD') === moment(this.end).format('YYYYMMDD');
      },
      name() {
        return this.room.text.short_name
      },
      description() {
        return this.room.text.short_desc
      },
      equipments() {
        return this.room.equipments.map(e => e.icon_dark)
      },
      pictures() {
        return this.room.pictures ? this.room.pictures.map(p => `${p.absolute_path}?w=800&h=470&crop-to-fit`) : []
      },
      startDate () {
        return moment(this.start).format('ddd DD MMM');
      },
      endDate () {
        return moment(this.end).format('ddd DD MMM');
      }
    },
    data() {
      return {
        currentPictureIndex: 0,
        duration: 5000,
        interval: null
      }
    },
    created() {
      this.startRotation()
    },
    beforeDestroy() {
      this.stopRotation()
    },
    methods: {
      startRotation() {
        if (this.interval) return;
        this.interval = setInterval(() => {
          this.goto(this.currentPictureIndex + 1);
        }, this.duration)
      },
      stopRotation() {
        if (!this.interval) return;
        clearInterval(this.interval);
        this.interval = null;
      },
      goto(index) {
        this.currentPictureIndex = index % this.pictures.length;
      },
      async openModal(imageArray, image) {
        await this.$store.dispatch('imageModal/modalize', {image, imageArray})
        await window.dispatchEvent(new Event('app:image-modal-slider.open'));
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/tunnel/step2/room-widget.vue